import React, { useContext, useEffect, useRef, useState } from "react";
import Card from "../../../../Base/Components/Card/Card";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import AutoCompleteDropdown from "../../../../Base/Components/Form/AutoCompleteDropdown";
import OverlayProveedorCAI from "../../../ERP/Suministros/Bodegas/IngresosBodega/IngresosCRUD/OverlayProveedorCAI";
import { Button } from "primereact/button";
import OverlayFacturaProveedor from "./Overlays Panel/OverlayFacturaProveedor";
import Loader from "../../../../Base/Components/Loader/Loader";
import {
  AnularRet,
  DetallesByConcepto,
  EditarComprobanteRetencion,
  EliminarDetalleRetencion,
  getDetallesEncabezado,
  GuardarComprobante,
  GuardarComprobanteRetencion,
} from "../../../../API/Finanzas/Retencion/ComprobanteRetencionRequest";
import AgGrid from "../../../../Base/Components/Tables/AgGrid/AgGrid";
import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext";
import { toastShow } from "../../../../Base/Services/ToastService";
import { Toast } from "primereact/toast";
import {
  ValidarFacturaProveedor,
  verificarCAI,
} from "../../../ERP/Compras/Proveedores/FuncionesProveedores";
import { RedondearNumero } from "../../../../Base/Utils/Funciones/Descargar";
import { setDateTimeSQLH } from "../../../../Base/Services/FechasService";
import { confirmDialog } from "primereact/confirmdialog";
import ReporteComprobanteRetencion from "./Reporte/ReporteComprobanteRetencion";
import { Dialog } from "primereact/dialog";
import OverlayPanelProveedores from "./Overlays Panel/OverlayPanelProveedores";

const EncabezadoComprobante = ({
  values,
  setValues,
  handleInputChange,
  conceptos,
  rangos,
  proveedores,
  estados,
  monedas,
  cuentas,
  habilitar,
  getValoresInicicales,
  getInfo,
  data,
  setData,
  error, 
  setError,
  encontrar
}) => {
  const { userAuth } = useContext(AuthContext);
  const toast = useRef(null);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState([]);
  const [reporteDialog, setReporteDialog] = useState(false);
  const [dialogAnular, setDialogAnular] = useState(false);
  const [errorComentario, setErrorComentario] = useState(false);
  const [datosReporte, setDatosReporte] = useState(null);

  const cambiarMontoD = (rowData) =>{
    if (rowData.newValue) {
        let detalle = rowData.data
        detalle.IdMoneda = values.IdMoneda
        detalle.Monto = Number(rowData.newValue)
        detalle.ImporteTotal = RedondearNumero(detalle.Monto * (detalle.Tasa / 100))

        detalle.MontoD = Number(rowData.newValue)
        detalle.MontoL = RedondearNumero(detalle.MontoD * values.TasaCambio)
        detalle.ImporteTotalD = detalle.ImporteTotal
        detalle.ImporteTotalL = RedondearNumero(detalle.ImporteTotalD * values.TasaCambio)

        let tempo = [...data]
        let index = tempo.findIndex((t) => t.IdComprobanteRetencionDet === detalle.IdComprobanteRetencionDet)
        tempo[index] = detalle
        setData(tempo)
      }
  }

  const cambiarMontoL = (rowData) =>{
    if (rowData.newValue) {
      let detalle = rowData.data
      detalle.IdMoneda = values.IdMoneda
      detalle.Monto = Number(rowData.newValue)
      detalle.ImporteTotal = RedondearNumero(detalle.Monto * (detalle.Tasa / 100))

      detalle.MontoL = Number(rowData.newValue)
      detalle.MontoD = RedondearNumero(detalle.MontoL / values.TasaCambio)
      detalle.ImporteTotalL = detalle.ImporteTotal
      detalle.ImporteTotalD = RedondearNumero(detalle.ImporteTotalL / values.TasaCambio)
      let tempo = [...data]
      let index = tempo.findIndex((t) => t.IdComprobanteRetencionDet === detalle.IdComprobanteRetencionDet)
      tempo[index] = detalle
      setData(tempo)
    }
  }

  const columns = [
    {
      field: "IdComprobanteRetencionDet",
      header: "ID",
      className: "Xsmall",
      filter: true,
      hidden: userAuth.IdRol === 1,
    },
    {
      field: "NoComprobanteRetencion",
      header: "Codigo",
      className: "Xsmall",
      filter: true,
    },
    {
      field: "DescripcionImpuestoRetenido",
      header: "Descripcion Impuesto Retenido",
      flex: 1,
      filter: true,
    },
    {
      field: "NoDocumento",
      header: "No. Documento",
      className: "large",
      filter: true,
      // editable: true,
      Sumary: "count",
      // onCellDoubleClicked: ({ data }) => {
      //     if (data?.IdFactura) {
      //         setIdFactura(data?.IdFactura)
      //         setDialogFactura(true)
      //     }
      // }
      // cellEditor: (data) => <InputNoDocumento datosD={data} />,
    },
    {
      field: "FechaDocumento",
      header: "Fecha Documento",
      className: "large",
      Format: "Date",
    },
    {
      field: "Tasa",
      header: "Tasa %",
      className: "Xsmall",
      Format: "Center",
      width: 70,
    },
    //Dolares
    {
      header: "Dolares",
      headerName: "Dolares",

      children: [
        {
          field: "MontoD",
          header: "Base de Retencion D",
          className: "large",
          Format: "Currency",
          Sumary: "sum",
          editable: true,
          onChange: (rowData) => {
            cambiarMontoD(rowData);
          },
        },
        {
          field: "ImporteTotalD",
          header: "Importe TotalD",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          // editable: true,
        },
      ],
    },

    //Lempiras
    {
      header: "Lempiras",
      headerName: "Lempiras",

      children: [
        {
          field: "MontoL",
          header: "Base de Retencion L",
          className: "large",
          Format: "Currency",
          Sumary: "sum",
          editable: true,
          onChange: (rowData) => {
            cambiarMontoL(rowData)
          },
        },
        {
          field: "ImporteTotalL",
          header: "Importe TotalL",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          // editable: true,
        },
      ],
    },
  ];

  const table = {
    Columns: columns,
    Data: data,
    loading: loading,
    // showModal: (e) => showModal(e),
    selected: selected,
    setSelected: (e) => setSelected(e),
  };

  const verificarInfo = () => {
    let error = {};
    if (!values?.FechaEmision) {
      error.FechaEmision = true;
      error.error = true;
    }
    if (!values?.DescripcionImpuestoRetenido?.IdConceptoRetencion && !values?.IdConceptoRetencion) {
      error.IdConceptoRetencion = true;
      error.error = true;
    }
    if (!values?.PrefijoRango?.IdRango && !values?.IdRango) {
      error.IdRango = true;
      error.error = true;
    }
    if (!values?.CustomerName?.IdVendor && !values?.IdVendor) {
      error.IdVendor = true;
      error.error = true;
    }
    if (!values?.IdProveedorCAI) {
      error.IdProveedorCAI = true;
      error.error = true;
    }
    setError(error);
    return error;
  };

  const guardarComprobante = async () => {
    const e = verificarInfo();
    if (e.error) {
      toastShow(
        toast,
        "warn",
        "Advertencia",
        "Completar los campos requeridos."
      );
      return;
    }

    if (!e?.error) {
      setLoading(true);
      const montoD = data.reduce((total, d) => total + d.ImporteTotalD, 0);
      const montoL = data.reduce((total, d) => total + d.ImporteTotalL, 0);
      const selectedProveedor = proveedores.find(prov => prov.IdCountry === 95); //Pais Honduras
      let idAccount;
      selectedProveedor ? idAccount = 15 : idAccount = 16;

      const selectedConcepto = conceptos.find((c) => c.IdConceptoRetencion === values?.DescripcionImpuestoRetenido?.IdConceptoRetencion || values?.IdConceptoRetencion);
      const cuentaCredito = selectedConcepto?.IdCuenta;
  
      const Datos = {
        IdComprobanteRetencionEnc: values?.IdComprobanteRetencionEnc,
        IdConceptoRetencion: values?.DescripcionImpuestoRetenido?.IdConceptoRetencion || values?.IdConceptoRetencion,
        FechaEmision: new Date(values?.FechaEmision),
        IdProveedorCAI: values?.IdProveedorCAI,
        IdRango: values?.PrefijoRango?.IdRango || values?.IdRango,
        IdMoneda: values?.Currency?.IdCurrency || values?.IdMoneda,
        MontoD: montoD,
        MontoL: montoL,
        TasaCambio: parseFloat(values?.TasaCambio),
        IdCuentaContable: values?.NombreCuenta?.IdAccount || values?.IdCuentaContable || idAccount,
        IdEstado: values?.StatusName?.IdStatus || values?.IdEstado,
        IdUserCreate: userAuth?.IdUser,
        IdUserEdit: userAuth?.IdUser,
        IdUserAnulado: userAuth?.IdUser,
        ComentarioAnulado: values?.ComentarioAnulado,
        IdCuentaCredito: cuentaCredito,
        IdCuentaDebito: idAccount,
      };
  
      const DatosDetalles = data.map((d) => ({
        ...d[0],
        IdComprobanteRetencionDet: d.IdComprobanteRetencionDet,
        IdFactura: d?.IdFactura,
        NoDocumento: d?.NoDocumento,
        FechaDocumento: d?.FechaDocumento,
        IdCuenta: values?.NombreCuenta?.IdAccount || values?.IdCuentaContable,
        MontoL: d?.MontoL,
        MontoD: d?.MontoD,
        IdMoneda: d?.IdMoneda,
        TasaCambio: d?.Tasa,
        ImporteTotalL: d?.ImporteTotalL,
        ImporteTotalD: d?.ImporteTotalD,
        IdEstado: d?.IdEstado,
        IdUserEdit: userAuth?.IdUser,
      }));

      if(DatosDetalles.length === 0){
        toastShow(toast, "warn", "Advertencia", "Es necesario agregar un detalle.");
        return
      }
  
      if (values?.IdComprobanteRetencionEnc > 0) {
        const respuestaDetalles = await EditarComprobanteRetencion(Datos, DatosDetalles);
        if (respuestaDetalles !== -1) {
          toastShow(toast, "success", "Editado", respuestaDetalles[0].MENSAJE);
          getInfo();
          getValoresInicicales();
          setLoading(false);
        } else {
          toastShow(
            toast,
            "error",
            "Error al editar",
            "Error al editar el comprobante."
          );
          setLoading(false);
        }
      } else {
        const respuestaDetalles = await GuardarComprobanteRetencion(Datos, DatosDetalles);
        if (respuestaDetalles !== -1) {
          toastShow(toast, "success", "Guardado", respuestaDetalles[0].MENSAJE);
          getInfo();
          setLoading(false);
        } else {
          toastShow(
            toast,
            "error",
            "Error al guardar",
            "Error al guardar el comprobante."
          );
          setLoading(false);
        }
      }
    }
  };

  const CambiarProveedorCAI = (e, op) => {
    let tempoValues = { ...values };
    tempoValues.IdProveedorCAI = e?.data?.IdProveedorCAI;
    tempoValues.NombreSucursal = e?.data?.NombreSucursal;
    tempoValues.NoCAI = e?.data?.NoCAI;
    tempoValues.Prefijo = e?.data?.Prefijo;
    tempoValues.FechaVencimiento = new Date(e?.data?.FechaVencimiento);
    tempoValues.RangoInicial = e?.data?.RangoInicial;
    tempoValues.RangoFinal = e?.data?.RangoFinal;
    if (!tempoValues.Factura) {
      tempoValues.Factura = e?.data.Prefijo;
    }
    setValues(tempoValues);
    op.current.toggle(e);
  };

  const VerificarRetencionesAnteriores = async (IdConcepto, detalles) => {
    const detallesRetenciones = await DetallesByConcepto(
      IdConcepto,
      detalles[0]?.IdVendor
    );
    if (detallesRetenciones?.length > 0) {
      let facturasIguales = detallesRetenciones?.filter((dr) =>
        detalles?.some((d) => dr?.IdFactura === d?.IdFactura)
      );
      return facturasIguales?.length > 0 ? true : false;
    }
  };

  // const AsignarInformacion = async (infoDet, op, e) => {
  //   let tempoValues = { ...values };

  //   const CR = conceptos?.filter((c) => c.IdConceptoRetencion === (tempoValues?.DescripcionImpuestoRetenido?.IdConceptoRetencion || tempoValues?.IdConceptoRetencion));

  //   const CodigoRetencion = CR[0]?.CodigoRetencion;
  //   const DescripcionImpuestoRetenido = CR[0]?.DescripcionImpuestoRetenido;
  //   const Tasa = CR[0]?.Tasa;

  //   const dataNueva = infoDet.map((i, index) => {
  //     const IdAleatorio = (data?.length + index + 1) * -1;

  //     return {
  //       IdComprobanteRetencionDet: IdAleatorio,
  //       IdComprobanteRetencionEnc: tempoValues?.IdComprobanteRetencionEnc,
  //       IdFactura: i.IdFactura,
  //       NoComprobanteRetencion: CodigoRetencion,
  //       DescripcionImpuestoRetenido: DescripcionImpuestoRetenido,
  //       NoDocumento: i.Factura,
  //       FechaDocumento: setDateTimeSQLH(i.FechaFactura),
  //       Monto: tempoValues.IdMoneda === 1 ? i.MontoD : i.MontoL,
  //       Tasa: Tasa,
  //       ImporteTotal: RedondearNumero(
  //         (tempoValues.IdMoneda === 1 ? i.MontoD : i.MontoL) * (Tasa / 100)
  //       ),
  //       RangoInicial: tempoValues.RangoInicial,
  //       RangoFinal: tempoValues.RangoFinal,
  //       Prefijo: tempoValues.Prefijo,
  //       IdEstadoDet: 1031,
  //       UserEdit: userAuth.IdUser,
  //       IdMoneda: tempoValues.IdMoneda,
  //       TasaCambio: tempoValues.TasaCambio,
  //       MontoL: i.MontoL,
  //       MontoD: i.MontoD,
  //       ImporteTotalL: RedondearNumero(i.MontoL * (Tasa / 100)),
  //       ImporteTotalD: RedondearNumero(i.MontoD * (Tasa / 100)),
  //     };
  //   });

  //   const nuevoArreglo = data.concat(dataNueva);
  //   setData(nuevoArreglo);

  //   if (e) {
  //     op?.current?.toggle(e);
  //   }
  // };

  const removerFila = async () => {
    if (selected.length <= 0) {
      toastShow(
        toast,
        "error",
        "Error",
        "Debe seleccionar las filas que desea eliminar"
      );
    } else {
      let message = <div>¿Está seguro que desea remover la fila?</div>;
      confirmDialog({
        message: message,
        header: "Confirmación",
        icon: "pi pi-exclamation-triangle",
        accept: async () => {
          setLoading(true);

          let user = userAuth.IdUser;
          let datosEnviar = [];

          selected.map((d) => {
            if (d.IdComprobanteRetencionDet > 0) {
              datosEnviar.push({
                IdComprobanteRetencionDet: d.IdComprobanteRetencionDet,
                IdEstadoDet: 90,
                UserEdit: user,
              });
            }
          });

          let listadoFinal = data.filter(
            (i) =>
              !selected.some(
                (e) =>
                  e.IdComprobanteRetencionDet === i.IdComprobanteRetencionDet
              )
          );
          if (datosEnviar?.length > 0) {
            const result = await EliminarDetalleRetencion(datosEnviar);
            if (result !== -1) {
              toastShow(toast, "success", "Eliminado", result[0].MENSAJE);
              getInfo();
              getValoresInicicales();
              setLoading(false);
            } else {
              toastShow(
                toast,
                "error",
                "Error al eliminar",
                "Error al eliminar el comprobante."
              );
              setLoading(false);
            }
          }

          setData(listadoFinal);
          setLoading(false);
          setSelected([]);
        },
        reject: () => {},
      });
    }
  };

  const AsignarInformacion = async (infoDet, op, e) => {
    let tempoValues = { ...values };

    if (values?.DescripcionImpuestoRetenido?.IdConceptoRetencion > 0) {
      if (infoDet?.length > 0) {
        const facturasIguales = await VerificarRetencionesAnteriores(
          values?.DescripcionImpuestoRetenido?.IdConceptoRetencion,
          infoDet
        );

        if (!facturasIguales) {
          let idExiste = data?.some((d) =>infoDet.some((i) => i.Id === d?.IdFactura));
          let CR = conceptos?.filter((c) => values?.DescripcionImpuestoRetenido?.IdConceptoRetencion || values?.IdConceptoRetencion === c.IdConceptoRetencion);

          let CodigoRetencion = CR[0]?.CodigoRetencion;
          let DescripcionImpuestoRetenido = CR[0]?.DescripcionImpuestoRetenido;
          let Tasa = CR[0]?.Tasa;

          if (!idExiste) {
            let dataNueva = await Promise.all(
              infoDet.map(async (i, index) => {
                let IdAleatorio = (data?.length + index + 1) * -1;
                if (values?.IdProveedorCAI > 0 && values?.Prefijo !== null) {
                  let infoCAI = {
                    IdProveedorCAI: values?.IdProveedorCAI,
                    Factura: i?.Documento,
                    FechaFactura: i?.FechaDocumento,
                  };

                  const validarCAI = await verificarCAI(infoCAI);
                  if (!validarCAI?.valido) {
                    toastShow(
                      toast,
                      "error",
                      `Factura ${i.Documento}`,
                      validarCAI?.msj
                    );
                    return null;
                  }
                } else {
                  let infoProveedor = {
                    IdVendor: i?.IdVendor,
                    IdProveedorCAI: null,
                    Factura: i?.Factura,
                    FechaFactura: i?.FechaFactura,
                  };

                  const CAIFactura = await ValidarFacturaProveedor(infoProveedor);

                  if (CAIFactura?.Valido) {
                    let CAIProveedor = CAIFactura?.Valores;
                    if (CAIProveedor) {
                      tempoValues.IdProveedorCAI = CAIProveedor?.IdProveedorCAI;
                      tempoValues.NombreSucursal = CAIProveedor?.NombreSucursal;
                      tempoValues.Prefijo = CAIProveedor?.Prefijo;
                      tempoValues.RangoInicial = CAIProveedor?.RangoInicial;
                      tempoValues.RangoFinal = CAIProveedor?.RangoFinal;
                      tempoValues.FechaVencimiento =
                        CAIProveedor?.FechaVencimiento;
                      tempoValues.RTN = CAIProveedor?.RTN;
                      tempoValues.CAI = CAIProveedor?.CAI;
                    }
                  } else {
                    toastShow(toast, "error", CAIFactura?.Mensaje);
                  }
                }

                return {
                  IdComprobanteRetencionDet: IdAleatorio,
                  IdComprobanteRetencionEnc: tempoValues?.IdComprobanteRetencionEnc,
                  IdFactura: i.IdFactura,
                  NoComprobanteRetencion: CodigoRetencion,
                  DescripcionImpuestoRetenido: DescripcionImpuestoRetenido,
                  NoDocumento: i.Factura,
                  FechaDocumento: setDateTimeSQLH(i.FechaFactura),
                  Monto: tempoValues.IdMoneda === 1 ? i.MontoD : i.MontoL,
                  Tasa: Tasa,
                  ImporteTotal: RedondearNumero(
                    (tempoValues.IdMoneda === 1 ? i.MontoD : i.MontoL) * (Tasa / 100)
                  ),
                  RangoInicial: tempoValues.RangoInicial,
                  RangoFinal: tempoValues.RangoFinal,
                  Prefijo: tempoValues.Prefijo,
                  IdEstadoDet: 1031,
                  UserEdit: userAuth.IdUser,
                  IdMoneda: tempoValues.IdMoneda,
                  TasaCambio: tempoValues.TasaCambio,
                  MontoL: i.MontoL,
                  MontoD: i.MontoD,
                  ImporteTotalL: RedondearNumero(i.MontoL * (Tasa / 100)),
                  ImporteTotalD: RedondearNumero(i.MontoD * (Tasa / 100)),
                };
              })
            );
            setValues(tempoValues);
            let dataNuevaF = dataNueva?.filter((d) => d !== null);

            let nuevoArreglo = data.concat(dataNuevaF);
            setData(nuevoArreglo);
            if (e) {
              op?.current?.toggle(e);
            }
          } else {
            toastShow(toast, "error", "No se aceptan facturas repetidas");
          }
        } else {
          toastShow(
            toast,
            "error",
            "Existen retenciones del mismo concepto creadas con las facturas seleccionadas"
          );
        }
      } else {
        if (e) {
          op?.current?.toggle(e);
        }
      }
    } else {
      toastShow(
        toast,
        "error",
        "Debe seleccionar el concepto de retención antes de ingresar las facturas"
      );
    }
  };


  const AnularRetencion = () =>{
    if (values?.ValorAcreditadoD > 0 || values?.ValorAcreditadoL > 0) {
      toastShow(toast, 'error', 'No se puede anular el comprobante de retención ya que tiene un pago');
      return
    }else{
      setDialogAnular(true);
    }
  }

  const DialogFooter = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={() => cerrrarDialog()}
      />
      <Button
        label={"Anular"}
        icon="pi pi-check"
        className="p-button-text"
        onClick={() => {anular()}}
      />
    </React.Fragment>
  );

  const anular = async () => {
    if (!values.ComentarioAnulado || values.ComentarioAnulado.trim() === "") {
      setErrorComentario(true);
      return;
    }
  
    setErrorComentario(false);
    const valor = {
      ...values,
      IdUserAnulado: userAuth?.IdUser
    }
    const anularRetencion = await AnularRet(valor);
    if (anularRetencion !== -1) {
      toastShow(toast, "success", "Anulado", anularRetencion[0].MENSAJE);
      getInfo();
      getValoresInicicales();
      cerrrarDialog();
      setLoading(false);
    } else {
      toastShow(
        toast,
        "error",
        "Error",
        "Error al anular el comprobante."
      );
      setLoading(false);
    }
  };

  const cerrrarDialog = () => {
    setDialogAnular(false);
    setErrorComentario(false);
    let tempoValues = { ...values };
    tempoValues.ComentarioAnulado = '';
    setValues(tempoValues);
  }
  

  const openReporte = (values) => {
    setReporteDialog(true)
    setDatosReporte(values)
  }

  const handleInputChangeProveedor = (e) => {
    const { name, value } = e.target;
  
    setValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  
    const proveedorSeleccionado = proveedores.find(
      (p) => p.IdVendor === value?.IdVendor
    );

    if (proveedorSeleccionado && proveedorSeleccionado.IdCountry === 95) {
      const cuentaLocal = cuentas.find((c) => c.IdAccount === 15);
  
      if (cuentaLocal) {
        setValues((prev) => ({
          ...prev,
          IdAccount: 15,
          NombreCuenta: cuentaLocal.NombreCuenta,
        }));
      }
    }else{
      const cuentaExterior = cuentas.find((c) => c.IdAccount === 16);
      setValues((prev) => ({
        ...prev,
        IdAccount: 16,
        NombreCuenta: cuentaExterior.NombreCuenta,
      }));
    }
  };
  
  useEffect(() => {
    if(encontrar){
      getValoresInicicales();
    }else{
      // if (!values?.CustomerName?.IdVendor || !values?.IdVendor) {
      //   let tempoValues = { ...values };
      //   tempoValues.IdProveedorCAI = null;
      //   tempoValues.NombreSucursal = "";
      //   tempoValues.NoCAI = "";
      //   tempoValues.Prefijo = "";
      //   tempoValues.FechaVencimiento = "";
      //   tempoValues.RangoInicial = "";
      //   tempoValues.RangoFinal = "";
      //   setValues(tempoValues);
      // }
    }
    getValoresInicicales()
  }, [encontrar]);

  return (
    <div>
      <Toast ref={toast} />
      <Card
        contenido={
          <div className="p-2">
            <div className="d-flex flex-wrap gap-2">
              {/* NoComprobanteRetencion */}
              <div className="p-float-label">
                <InputText
                  id="NoComprobanteRetencion"
                  name="NoComprobanteRetencion"
                  value={values?.NoComprobanteRetencion}
                  onChange={handleInputChange}
                  style={{ fontWeight: "bold" }}
                  enable={!habilitar}
                />
                <label htmlFor="NoComprobanteRetencion">No. Retención</label>
              </div>

              {/* FechaEmision */}
              <div className="p-float-label">
                <Calendar
                  id="FechaEmision"
                  name="FechaEmision"
                  value={values.FechaEmision}
                  onChange={handleInputChange}
                  dateFormat="dd/mm/yy"
                  mask="99/99/9999"
                  style={{ height: 40 }}
                  showIcon
                  className={error.FechaEmision ? "p-invalid" : ""}
                  disabled={habilitar}
                />
                <label htmlFor="FechaEmision">Fecha Emisión</label>
              </div>

              {/* DescripcionImpuestoRetenido */}
              <div style={{ width: "450px" }}>
                <AutoCompleteDropdown
                  name={"DescripcionImpuestoRetenido"}
                  value={values?.DescripcionImpuestoRetenido}
                  items={conceptos}
                  field={"DescripcionImpuestoRetenido"}
                  label={"Concepto de Retención"}
                  handleInputChange={handleInputChange}
                  className={error.IdConceptoRetencion ? "p-invalid" : ""}
                  enable={!habilitar}
                  disabled
                />
              </div>

              {/* PrefijoRango */}
              <div>
                <AutoCompleteDropdown
                  name={"PrefijoRango"}
                  value={values?.PrefijoRango}
                  items={rangos}
                  field={"PrefijoRango"}
                  label={"Rango de Retención"}
                  handleInputChange={handleInputChange}
                  className={error.IdRango ? "p-invalid" : ""}
                  enable={false}
                  disabled
                />
              </div>

              {/* proveedores */}
              <div style={{ width: "350px" }}>
                <AutoCompleteDropdown
                  name={"CustomerName"}
                  value={values?.CustomerName}
                  items={proveedores}
                  field={"CustomerName"}
                  label={"Proveedor"}
                  handleInputChange={handleInputChangeProveedor}
                  className={error.IdVendor ? "p-invalid" : ""}
                  enable={!habilitar}
                  disabled
                />
              </div>

              {/* CAI */}
              <div className="d-flex flex-row">
                <span className="p-float-label">
                  <InputText
                    value={values.NombreSucursal}
                    style={{ width: "100%", borderEndEndRadius: 0 }}
                    disabled={habilitar}
                    className={error.IdProveedorCAI ? "p-invalid" : ""}
                  />
                  <label htmlFor="NombreSucursal">CAI</label>
                </span>

                <OverlayProveedorCAI
                  IdProveedor={
                    values.CustomerName?.IdVendor || values?.IdVendor
                  }
                  values={values}
                  onChange={CambiarProveedorCAI}
                  habilitar={(values.CustomerName?.IdVendor || values?.IdVendor) && !habilitar}
                />
              </div>

              {/* NoCAI */}
              <div className="field p-float-label">
                <InputText
                  id="NoCAI"
                  name="NoCAI"
                  value={values?.NoCAI}
                  onChange={handleInputChange}
                  style={{ width: "445px" }}
                  disabled
                />
                <label htmlFor="NoCAI">CAI</label>
              </div>

              {/* Prefijo */}
              <div className="field p-float-label">
                <InputText
                  id="Prefijo"
                  name="Prefijo"
                  value={values?.Prefijo}
                  onChange={handleInputChange}
                  style={{ width: "210px" }}
                  disabled
                />
                <label htmlFor="Prefijo">Prefijo</label>
              </div>

              {/* FechaVencimiento */}
              <div className="p-float-label">
                <Calendar
                  id="FechaVencimiento"
                  name="FechaVencimiento"
                  value={values.FechaVencimiento}
                  onChange={handleInputChange}
                  dateFormat="dd/mm/yy"
                  mask="99/99/9999"
                  style={{ height: 40 }}
                  showIcon
                  disabled
                />
                <label htmlFor="FechaVencimiento">Fecha de Vencimiento</label>
              </div>

              {/* RangoInicial */}
              <div className="field p-float-label">
                <InputText
                  id="RangoInicial"
                  name="RangoInicial"
                  value={values?.RangoInicial}
                  onChange={handleInputChange}
                  disabled
                />
                <label htmlFor="RangoInicial">Rango Inicial</label>
              </div>

              {/* RangoFinal */}
              <div className="field p-float-label">
                <InputText
                  id="RangoFinal"
                  name="RangoFinal"
                  value={values?.RangoFinal}
                  onChange={handleInputChange}
                  disabled
                />
                <label htmlFor="RangoFinal">Rango Final</label>
              </div>

              {/* Estados */}
              <div>
                <AutoCompleteDropdown
                  name={"StatusName"}
                  value={values?.StatusName}
                  items={estados}
                  field={"StatusName"}
                  label={"Estado"}
                  handleInputChange={handleInputChange}
                  enable={values?.IdComprobanteRetencionEnc > 0 && !habilitar}
                  disabled
                />
              </div>
            </div>

            <div className="mt-4 d-flex gap-2">
              <div>
                <OverlayFacturaProveedor
                  IdVendor={values?.CustomerName?.IdVendor}
                  habilitar={((values?.CustomerName?.IdVendor > 0 && values?.DescripcionImpuestoRetenido?.IdConceptoRetencion > 0) || (values?.IdVendor && values?.IdConceptoRetencion)) && !habilitar}
                  AsignarInformacion={AsignarInformacion}
                  IdConceptoRetencion={
                    values?.IdConceptoRetencion ||
                    values?.DescripcionImpuestoRetenido?.IdConceptoRetencion
                  }
                />
              </div>

              <div>
                <Button
                  icon="pi pi-save"
                  disabled={habilitar}
                  className="p-button-primary encabezado__herramienta-botones"
                  tooltip="Guardar"
                  tooltipOptions={{
                    className: "purple-tooltip",
                    position: "top",
                  }}
                  style={{ marginLeft: 1 }}
                  onClick={(e) => {
                    guardarComprobante();
                  }}
                />
              </div>

              <div>
                <Button
                  icon="pi pi-times"
                  onClick={() => removerFila()}
                  severity="danger"
                  disabled={habilitar}
                  tooltip="Eliminar"
                  tooltipOptions={{
                    className: "purple-tooltip",
                    position: "top",
                  }}
                />
              </div>

              <OverlayPanelProveedores/>

              <div>
                <Button
                  icon="pi pi-print"
                  onClick={() => openReporte(values)}
                  disabled={values.IdComprobanteRetencionEnc < 0}
                  tooltip="Reporte"
                  tooltipOptions={{
                    className: "purple-tooltip",
                    position: "top",
                  }}
                />
              </div>

              <div>
                <Button
                  icon="pi pi-sync"
                  type="button"
                  severity="secondary"
                  className="p-button-info encabezado__herramienta-botones"
                  onClick={(e) =>
                    getValoresInicicales()
                  }
                  tooltip="Cargar"
                  tooltipOptions={{
                    className: "purple-tooltip",
                    position: "top",
                  }}
                  style={{ marginLeft: 1 }}
                />
              </div>

              <div style={{ width: "150px", marginLeft: 15 }}>
                <AutoCompleteDropdown
                  name={"Currency"}
                  value={values?.Currency}
                  items={monedas}
                  field={"Currency"}
                  label={"Moneda"}
                  handleInputChange={handleInputChange}
                  enable={!habilitar}
                  disabled
                />
              </div>

              <div className="field p-float-label">
                <InputText
                  id="TasaCambio"
                  name="TasaCambio"
                  value={values?.TasaCambio}
                  onChange={handleInputChange}
                  disabled={habilitar}
                />
                <label htmlFor="TasaCambio">Tasa Cambio</label>
              </div>

              <div style={{ width: "450px" }}>
                <AutoCompleteDropdown
                  enable={!habilitar}
                  name={"NombreCuenta"}
                  value={values?.NombreCuenta}
                  items={cuentas}
                  field={"NombreCuenta"}
                  label={"Cuenta Débito"}
                  handleInputChange={handleInputChange}
                />
              </div>

              {values.IdComprobanteRetencionEnc > 0 ?
                <Button icon='ri-file-close-line' tooltip='Anular Retención'
                    onClick={() => AnularRetencion()}
                    label='Anular Retención'
                    disabled={habilitar} />
              : null}
            </div>

            <div className="pt-4">
              {/* <Loader loading={loading} querySelector="#DetalleComprobante" /> */}
              <div style={{ height: "60vh" }} id="DetalleComprobante">
                <AgGrid table={table} />
              </div>

              {values?.ComentarioAnulado && values?.UserNameAnulado &&(
                <div className="d-flex justify-content-end">
                  <div>
                    <p style={{ fontWeight: '600', marginBottom: "1px" }}>
                      Comentario Anulado:{" "}
                      <span className="fw-normal">
                        {values?.ComentarioAnulado}
                      </span>
                    </p>

                    <p style={{ fontWeight: '600' }}>
                      Usuario Anulo:{" "}
                      <span className="fw-normal">
                        {values?.UserNameAnulado}
                      </span>
                    </p>
                  </div>
                </div>
              )}
            </div>

          </div>
        }
      />

      <ReporteComprobanteRetencion
       reporteDialog={reporteDialog}
       setReporteDialog={setReporteDialog}
       datosReporte={datosReporte}
       setDatosReporte={setDatosReporte}
      />

      {/* Anular Retencion */}
      <Dialog
        visible={dialogAnular}
        header='Anular Retención'
        onHide={() => cerrrarDialog()}
        style={{width:'30%'}}
        footer={DialogFooter}>

        <div className="mt-2">
          <span className="p-float-label ">
            <InputText
              value={values?.ComentarioAnulado}
              onChange={(e) => {
                handleInputChange(e, "ComentarioAnulado");
                setErrorComentario(false);
              }}
              style={{ width: "100%", borderColor: errorComentario ? "red" : undefined }}
              disabled={habilitar}
            />
            <label htmlFor="ComentarioAnulado">Comentario</label>
          </span>
        </div>
      </Dialog>
    </div>
  );
};

export default EncabezadoComprobante;
